{
  "#PMS_ROSTER": {
    "TITLE": "Dienstplaner",
    "NEW_ENTRY": "Neuer Eintrag",
    "NEW_ROSTER_ENTRY": "Neuer Dienstplan-Eintrag",
    "PLAN_ENTRY": "Planeintrag",
    "APPOINTMENT": "Termin",
    "REFRESH": "Aktualisieren",
    "EDIT": "Editieren",
    "DUPLICATE": "Duplizieren",
    "COPY": "Kopieren",
    "DELETE": "Löschen",
    "SAVE": "Speichern",
    "CREATE": "Erstellen",
    "NEXT": "Weiter",
    "SEARCH": "Suchen...",
    "SELECTED": "ausgewählt",
    "VIEW": "Ansicht",
    "SELECTION": "Auswahl",
    "VIEW_TYPE": "Zeitraum",
    "COLUMN_WIDTH": "Spaltenbreite",
    "EVENT_TYPES": "Eintragsarten",
    "DETAILS": "Details",
    "VIEW_TYPE_DAY": "Tag",
    "VIEW_TYPE_WORK_WEEK": "Arbeitswoche",
    "VIEW_TYPE_WEEK": "Woche",
    "VIEW_TYPE_MONTH": "Monat",
    "VIEW_TYPE_PLAN_MONTH": "Planeinteilung Monat",
    "COLUMN_WIDTH_SMALL": "Schmal",
    "COLUMN_WIDTH_NORMAL": "Normal",
    "COLUMN_WIDTH_LARGE": "Breit",
    "DETAILS_COMPACT": "Kompakt",
    "DETAILS_ALL": "Details",
    "FILTER_TICKETS_OBJECTS_TASKS": "Tickets, Objekte, Aufgaben",
    "FILTER_APPOINTMENTS": "Kalendereinträge (Termine)",
    "FILTER_ABSENCES": "Abwesenheiten (Urlaub/ZA)",
    "COPY_TICKET_NR": "Ticket-Nr. kopieren",
    "OPEN_TICKET": "Ticket öffnen",
    "COPY_OBJECT_NR": "Objekt-Nr. kopieren",
    "COPY_TO_NEXT_MONDAY": "Auf nächsten Montag kopieren",
    "CHANGE_STATUS": "Status ändern",
    "STATUS_UNDEFINED": "Undefiniert",
    "STATUS_DONE": "Erledigt",
    "STATUS_FORWARDED": "Weitergeleitet",
    "STATUS_UNDER_REVIEW": "Intern überprüfen",
    "STATUS_CHANGED_SUCCESS": "Status wurde erfolgreich geändert.",
    "WAS_CREATED": "wurde erstellt.",
    "ENTRY_CREATED": "Dienstplan-Eintrag wurde erstellt.",
    "ENTRY_CREATE_ERROR": "Fehler beim Erstellen des Eintrags.",
    "NO_DEPARTMENT_HEADS": "Keine Abteilungsleiter gefunden.",
    "DELETE_CONFIRM": "Möchten Sie diese(n) Eintrag(e) löschen?",
    "CREATE_ENTRY_TITLE": "Neue Dienstplan-Eintrag erstellen",
    "CREATE_ENTRY_SUBTITLE": "Geben Sie die Details für den neuen Eintrag ein.",
    "EDIT_ENTRY_TITLE": "Dienstplan-Eintrag bearbeiten",
    "EDIT_ENTRY_SUBTITLE": "Erstellt von {{creatorUser}} am {{createdAt:'dd.MM.yyyy, HH:mm'}}",
    "DETAILS_SUBTITLE": "Details zum Eintrag festlegen",
    "CANCEL": "Abbrechen",
    "FORM": {
      "WHAT_TO_CREATE": "Was möchten Sie erstellen?",
      "CREATE_PLAN_ENTRY": "Planeintrag erstellen",
      "PLAN_ENTRY_DESC": "Kann mit Tickets oder Objekten verknüpft werden",
      "CREATE_APPOINTMENT": "Termin erstellen",
      "APPOINTMENT_DESC": "Demnächst verfügbar - Mit Betreff, Ort, Beschreibung und Teilnehmern",
      "SELECT_PARTICIPANTS": "Teilnehmer auswählen",
      "OTHER_DEPARTMENTS": "Andere Abteilungen",
      "SELECT_EMPLOYEE": "Mitarbeiter auswählen",
      "CHOOSE_PARTICIPANTS": "Wählen Sie die Teilnehmer",
      "CHOOSE_EMPLOYEE": "Wählen Sie den Bearbeiter",
      "PARTICIPANTS_SELECTED": "Teilnehmer ausgewählt",
      "ENTRY_TYPE": "Eintragsart",
      "SELECT_ENTRY_TYPE": "Eintragsart auswählen",
      "PARTICIPANT": "Teilnehmer",
      "EMPLOYEE": "Bearbeiter",
      "DATE_TIME": "Datum & Uhrzeit",
      "SET_DATE_TIME": "Datum und Uhrzeit festlegen",
      "TICKET_OBJECT": "Ticket/Objekt",
      "SUBJECT_DESCRIPTION": "Betreff und Beschreibung",
      "LINK_ARTIFACT": "Verknüpfe ein Artefakt",
      "DATE": "Datum",
      "START_TIME": "Startzeit",
      "END_TIME": "Endzeit",
      "DURATION": "Dauer",
      "SUBJECT": "Betreff",
      "STATUS": "Status",
      "DESCRIPTION": "Beschreibung",
      "TICKET": "Ticket",
      "TICKET_NUMBER": "Ticketnummer",
      "TICKET_NOT_FOUND": "Ticket nicht gefunden",
      "SEARCH_RESOURCES": "Ressourcen durchsuchen..."
    },
    "TASKS_LIST": {
      "TICKETS": "Tickets",
      "OBJECTS": "Objekte",
      "STATUS": "Status",
      "PLANNED_NOT_FINISHED": "Geplante, nicht erledigte",
      "ALL_OPEN": "Alle Offenen",
      "OPEN_WITH_TIME_TRACKING": "Offene mit Zeiterfassung",
      "OVERDUE": "Überfällige",
      "FILTERED_BY_EMPLOYEES": "Gefiltert nach Mitarbeiter(n):",
      "SEARCH_TICKETS": "Durchsuche Tickets...",
      "NO_TICKETS_FOUND": "Keine Tickets gefunden",
      "LOADING_TICKETS": "Lade Tickets...",
      "LOADING_TICKET": "Lade Ticket...",
      "EXPAND_COLLAPSE_ALL": "Alle Tickets erweitern/zusammenklappen",
      "SORT_TICKET_NR": "Ticket-Nr auf- oder absteigend sortieren",
      "REFRESH_TICKETS": "Tickets neu laden",
      "SEARCH_OBJECTS": "Durchsuche Objekte...",
      "NO_OBJECTS_FOUND": "Keine Objekte gefunden",
      "LOADING_OBJECTS": "Lade Objekte...",
      "LOADING_OBJECT": "Lade Objekt...",
      "SORT_OBJECT_NR": "Objekt-Nr auf- oder absteigend sortieren",
      "REFRESH_OBJECTS": "Objekte neu laden",
      "AL_COST_CENTERS": "AL Kostenstellen",
      "PROJECT_LEADER": "Projektleiter",
      "PARTICIPANT": "Teilnehmer"
    },
    "TICKET_CARD": {
      "SHOW_DETAILS": "Details anzeigen",
      "COPY_TICKET": "Ticket kopieren",
      "OPEN_TICKET_TAB": "Ticket in neuen Tab öffnen",
      "CREATED_ON": "Erstellt am",
      "DUE_BY": "Zu erledigen bis",
      "LAST_PLANNED_ON": "Letztes mal geplant am:",
      "BILLABLE": "Verrechenbar"
    },
    "OBJECT_CARD": {
      "OBJECT": "Objekt"
    },
    "RESOURCE": {
      "OPEN": "offen",
      "PLANNED_NOT_DONE": "geplante, nicht erledigte",
      "TIME_COMPENSATION": "ZA:"
    },
    "TIMELINE": {
      "NO_ENTRIES": "Keine Einträge für diesen Tag vorhanden."
    },
    "APPOINTMENT_CARD": {
      "EMPTY_PLAN_ENTRY": "Leerer Planeintrag",
      "EMPTY_APPOINTMENT": "Leerer Termin",
      "ATTENDEES": "Teilnehmer",
      "ORGANIZER": "Organisator"
    },
    "EVENT": {
      "UNNAMED": "Unbenannt"
    },
    "EXTERNAL_EVENT": {
      "TITLE": "Externer Termin"
    }
  }
}
